module.exports = __webpack_public_path__ + "static/black-flags-371ec77e8b7113d7122619c5257370af.jpg";